import { render } from "./SupplierDetail.vue?vue&type=template&id=1afbf658"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"

import "./SupplierDetail.vue?vue&type=style&index=0&id=1afbf658&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__